import React, {FormEvent, useEffect, useState} from "react";
import {LoginService} from "./login.service";
import {Card, CardActions, CardContent, CardMedia, Grid} from "@mui/material";
import {useNavigate} from "react-router-dom";
import CustomTextField from "../typescript/custom-text-field/custom-text-field";
import CustomButton from "../typescript/custom-button/custom-button";
import {AppService} from "../typescript/app/app.service";
import {UserService} from "../user/user.service";
import theme from "../typescript/theme/theme";

export function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    let navigate = useNavigate();

    useEffect(() => {
        AppService.logout();
    }, []);

    const authenticate = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setError("");
        setLoading(true);
        try {
            const loginSuccessfully = await LoginService.authenticate(username, password);
            if (loginSuccessfully) {
                const getUserDetailsSuccessfully = await UserService.getMe();
                if (getUserDetailsSuccessfully) {
                    await UserService.getAvatarOfCurrentUser();
                    let from = AppService.getFrom();
                    navigate(from);
                }
            } else {
                setError("Usuário ou senha inválidos.");
            }
        } catch (e) {
            setError("Erro ao autenticar. Tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid sx={theme.loginContainer}>
            <form onSubmit={authenticate} autoComplete="on" aria-label="Formulário de login">
                <Card sx={theme.loginCard}>
                    <CardMedia sx={theme.loginMedia} image="/copacubana.png"/>
                    <CardContent>
                        <CustomTextField
                            fullWidth
                            autoFocus
                            required
                            placeholder="Digite o seu usuário"
                            label="Usuário"
                            value={username}
                            onChange={e => {
                                setUsername(e.target.value);
                                if (error) setError("");
                            }}
                            name="username"
                            autoComplete="username"
                            inputProps={{
                                autoCapitalize: "none",
                                "aria-label": "Usuário"
                            }}
                        />
                        <CustomTextField
                            fullWidth
                            required
                            placeholder="Digite a sua senha"
                            label="Senha"
                            type="password"
                            value={password}
                            onChange={e => {
                                setPassword(e.target.value);
                                if (error) setError("");
                            }}
                            name="password"
                            autoComplete="current-password"
                            inputProps={{
                                "aria-label": "Senha"
                            }}
                        />
                        <div style={{minHeight: 24, marginTop: 8}}>
                            {error && <span style={{color: "red"}}>{error}</span>}
                        </div>
                    </CardContent>
                    <CardActions sx={theme.loginButtonBar}>
                        <CustomButton color="primary" type="submit" disabled={loading}>
                            {loading ? "Entrando..." : "Login"}
                        </CustomButton>
                    </CardActions>
                </Card>
            </form>
        </Grid>
    );
}